import React, {useLayoutEffect, useState} from "react";
import '../../resources/css/application.css';
import Carousel from "react-gallery-carousel";
import * as PropTypes from "prop-types";

const ImagesPreview = (props) => {

  const {images, showPreview, setShowPreview} = props;
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useLayoutEffect(() => {
    if (showPreview) {
      window.addEventListener("orientationchange", orientationChangeListener, false);
      window.addEventListener("keydown", event => {
        if (event.key === "Escape") {
          setShowPreview(false);
        }
      });
      addCurrentImageNameOnPreview();
    }
    window.removeEventListener("orientationchange", orientationChangeListener, false);
  });

  const addCurrentImageNameOnPreview = () => {
    const parent = document.getElementsByClassName("_Pfcmb")[0];
    const div = document.createElement("div");

    div.setAttribute("id", "imageNameId");
    div.setAttribute("class", "_3lwW_ _1R7KP_image-name _29p_Y");

    const span = document.createElement("span");
    span.setAttribute("class", "__JnHV");
    span.innerHTML = document.getElementsByClassName("_1eGao")[currentImageIndex].children[0].ariaLabel;

    div.appendChild(span);
    parent.appendChild(div);
  };

  const removeCurrentImageNameOnPreview = () => {
    const imageNameDiv = document.getElementById("imageNameId");
    if (imageNameDiv) {
      imageNameDiv.remove();
    }
  };

  const changeImageIndexOnPreview = (index) => {
    setCurrentImageIndex(index.curIndex);
    if (currentImageIndex !== index.curIndex) {
      removeCurrentImageNameOnPreview();
    }
  };

  const orientationChangeListener = () => {
    removeCurrentImageNameOnPreview();
    addCurrentImageNameOnPreview();
  };

  const closeImagesPreview = () => {
    setShowPreview(false);
  };

  return (
    <div>
      <Carousel
        minIcon={<span onClick={closeImagesPreview} className="close-button">&times;</span>}
        shouldMinimizeOnSwipeDown={false} isMaximized={true} hasMediaButton={false} canAutoPlay={false}
        onIndexChange={changeImageIndexOnPreview} index={currentImageIndex}
        images={images.filter(img => img !== null).map((image) => ({
          src: image.dataURL, alt: image.file.name.split(".")[0]
        }))}/>
    </div>
  );
};

ImagesPreview.propTypes = {
  images: PropTypes.array.isRequired,
  showPreview: PropTypes.bool.isRequired,
  setShowPreview: PropTypes.func.isRequired
};

export default ImagesPreview;
